import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 1h13v13H1V1zm1 1v11h11V2H2z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgSquare = styled(BaseComponent)`
  outline: none;
`
export default SvgSquare
